import { render } from "./NumericCell.vue?vue&type=template&id=6c246f2c&scoped=true"
import script from "./NumericCell.vue?vue&type=script&lang=js"
export * from "./NumericCell.vue?vue&type=script&lang=js"

import "./NumericCell.vue?vue&type=style&index=0&id=6c246f2c&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c246f2c"]])

export default __exports__